import React from 'react';
import { FacebookLogin } from '../auth/facebook-login';
import { ScopelyLogin } from '../auth/scopely-login';
import Image from 'next/image';
import styles from './unauthorized-panel.module.css';
import { cn } from '@wwe-portal/ui/lib/lib';

export const UnauthorizedPanel = ({
  title = '',
  isLoggedIn,
  description = '',
}: {
  title?: string;
  isLoggedIn: boolean;
  description?: string;
}) => {
  return (
    <div
      className={cn(
        styles.panel,
        'flex flex-col items-center justify-center text-center'
      )}
    >
      <Image
        src="/assets/icons/chat-panel-join-icon.svg"
        alt="chat-panel-icon"
        width={150}
        height={100}
        className="mb-8"
      />
      {title && <h5 className="text-text700 capitalize">{title}</h5>}
      {description && (
        <p className="text-text600 pb-4 text-xs">{description}</p>
      )}
      {!isLoggedIn && (
        <div className="w-full">
          <FacebookLogin className="mt-[15px] w-full" />
          <ScopelyLogin className="mt-[15px] w-full" />
        </div>
      )}
    </div>
  );
};
